module.exports = __webpack_public_path__ + "static/010-afccb8b34d5fc61807c4ed5a6a323552.jpg";